import getApiClient from "../../../../shared/api";
import {
  showInfo,
  showError,
  clearNotifications
} from "../../../../notifications/ducks/actions";

export function fetchScenesScriptDays(filmId) {
  return (dispatch) => {
    dispatch({
      type: "FETCH_SCENES_SCRIPT_DAYS",
      payload: getApiClient().get(`/film/${filmId}/scene/scriptDays`)
    });
  };
}

export function updateScenesScriptDays(filmId, days) {
  const command = { days };
  return (dispatch) => {
    dispatch({
      type: "UPDATE_SCENES_SHOOTING_SCRIPT_DAYS",
      payload: getApiClient().put(
        `/film/${filmId}/scene/scriptDays`,
        command
      ),
      meta: { days }
    })
      .then((response) => {
        dispatch(showInfo(`Updated scene script days`));
      })
      .catch((response) => {
        dispatch(showError(`Error updating scene script days`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function updateOrder(startIndex, endIndex) {
  return (dispatch) => {
    dispatch({
      type: "REORDER_SCENES_SCRIPT_DAYS",
      meta: { startIndex, endIndex }
    });
  };
}

export function updateSceneOrder(
  startIndex,
  endIndex,
  sourceDay,
  destinationDay
) {
  return (dispatch) => {
    dispatch({
      type: "REORDER_SCENES_SCRIPT_DAY_SCENES",
      meta: { startIndex, endIndex, sourceDay, destinationDay }
    });
  };
}

export function updateDayOrder(startIndex, endIndex) {
  return (dispatch) => {
    dispatch({
      type: "REORDER_SCENES_SCRIPT_DAYS",
      meta: { startIndex, endIndex }
    });
  };
}

export function addScriptDay() {
  return (dispatch) => {
    dispatch({
      type: "ADD_SCENES_SCRIPT_DAY"
    });
  };
}

export function deleteScriptDay(dayNumber) {
  return (dispatch) => {
    dispatch({
      type: "DELETE_SCENES_SCRIPT_DAY",
      meta: { dayNumber }
    });
  };
}

export function clearRedirect(dispatch) {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_REDIRECT"
    });
  };
}

export function toggleSelectionInGroup(sceneId) {
  return (dispatch) => {
    dispatch({
      type: "SCENES_SCRIPT_DAY_TOGGLE_SELECTION_IN_GROUP",
      meta: { sceneId }
    });
  };
}

export function multiSelectTo(sceneId) {
  return (dispatch) => {
    dispatch({
      type: "SCENES_SCRIPT_DAY_MULTI_SELECT_TO",
      meta: { sceneId }
    });
  };
}

export function setDraggingSceneId(sceneId) {
  return (dispatch) => {
    dispatch({
      type: "SCENES_SCRIPT_DAY_SET_DRAGGING_SCENE_ID",
      meta: { sceneId }
    });
  };
}

export function unselectAll() {
  return (dispatch) => {
    dispatch({
      type: "SCENES_SCRIPT_DAY_UNSELECT_ALL"
    });
  };
}